import script from "./PaymentButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentButton.vue?vue&type=script&setup=true&lang=js"

import "./PaymentButton.vue?vue&type=style&index=0&id=541950a1&lang=css"

const __exports__ = script;

export default __exports__